import React, { useState, useEffect } from 'react';
import { Layout, Menu, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import headerStyle from './header.module.less';
const { Header } = Layout;
import * as constants from '../../../constants/constants';
import localStorage from 'localStorage';
import logoSvg from '../../../static/image/logo.svg';
import Cookies from 'js-cookie';
import LoginRegisterModal from '../../../component/modal/login-register/login-register';
import UserInfo from '../user-center/user-info';
import { sendHttpPostRequest } from '../../../api/http-request';
export interface Props {
    keys: any
}

export const PageHeader: React.FC<Props> = (props: Props) => {
    const { keys } = props
    const [collegeInfo, setCollegeInfo] = useState(null as any);//查询当前用户的机构信息,is_college_teacher weitrue表示是教师，
    const [isLocalDeploy, setIsLocalDeply] = useState(false) //是否本地部署

    /**
     * 查询后端，返回是否是本地部署
     */
    const checkIsLocalDeploy = () => {

    let data = {

    }
    try {
        sendHttpPostRequest(
        'get_is_deploy',
        data,
        (response)=> {

            if (response.is_ok) {
            if(response?.deploy_type == 2){
                setIsLocalDeply(true)
            }
            } else {
            //message.error('密码重置失败，请稍候再试')
            }
        }
        )
    } catch (e) {
        console.error(e)
    }
    }


    useEffect(()=> {
        keys != -1 && document.getElementById('menu-' + keys) != null ? document.getElementById('menu-' + keys)!.click() : "";
        const cachedCollegeInfo = JSON.parse(localStorage.getItem("college_info"));

        checkIsLocalDeploy()
        if (cachedCollegeInfo) {

            setCollegeInfo(cachedCollegeInfo);
            
        } else {
            sendHttpPostRequest(//获取院校身份信息
                'account/api/query_teacher_authenticate',{
                    sessionid: Cookies.get("sessionid"),
                    sid: Cookies.get("sessionid"),
                },
                (response:any)=>{
                    if(response.is_ok == true)
                    {
                        let _collegeId = response.college_info.college_id;
                        if(_collegeId && _collegeId !== 0){
                            
                            setCollegeInfo(response.college_info);
                            
                            localStorage.setItem("college_info", JSON.stringify(response.college_info));
                        }
                    }
                }
            );
        }
    },[])

    return (
        <Header className={headerStyle.Header} >
            <Row justify="center" align="middle" wrap={true}>
            {(collegeInfo && collegeInfo?.logo_url !== '') ?
                <Col>
                    <Link to={"/"}>
                        <img
                            key={"0"}
                            id={"menu-0"}
                            title="爱数课"
                            alt="logo"
                            src={ collegeInfo?.logo_url ? constants.BACKEND_API_URL + collegeInfo?.logo_url : logoSvg}
                            height="40px"
                            className={headerStyle.logo}
                        ></img>
                    </Link>
                </Col> :
                <Col>
                <Link to={"/"}>
                    <img
                        key={"0"}
                        id={"menu-0"}
                        title="爱数课"
                        alt="logo"
                        src={logoSvg}
                        height="40px"
                        className={headerStyle.logo}
                    ></img>
                </Link>
            </Col> 
                
                }
                
                <Col flex="auto">
                    <Menu
                        theme="light"
                        mode="horizontal"
                        selectedKeys={keys}
                        style={{fontSize:16, fontWeight:500, float:'right',  width:590, borderBottom:'0px',height:64,marginTop:0}}
                        onClick={()=>{}}
                        inlineCollapsed={false}
                    > 
                        <Menu.Item key="2" id={"menu-2"}><Link to={'/case'}>在线实验</Link></Menu.Item>
                        <Menu.Item key="1" id={"menu-1"}><Link to={'/course'}>课程学习</Link></Menu.Item>
                        <Menu.Item key="5" id={"menu-5"}><Link to={'/lecture'}>数智讲堂</Link></Menu.Item>
                        <Menu.Item key="7" id={"menu-7"}><Link to={'/ai_learn'}>AI问学</Link></Menu.Item>

                       { isLocalDeploy == true && <Menu.Item key="6" id={"menu-6"}><Link to={'/community'}>社区</Link></Menu.Item> }

                       {collegeInfo?.is_college_teacher == 1 &&  <Menu.SubMenu title="资源中心">
                            <Menu.Item key="3" id={"menu-3"}><Link to={'/module'}>知识点</Link></Menu.Item>
                            <Menu.Item key="4" id={"menu-4"}><Link to={'/exercise'}>题库</Link></Menu.Item>
                        </Menu.SubMenu> }
                    </Menu>

           

                </Col>

                <Col >
                    <LoginRegisterModal></LoginRegisterModal>
                    <UserInfo>
                    </UserInfo>
                </Col>

            </Row>
        </Header>
    )
}

export default PageHeader



